<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">
		<smart-input required :errors="inputErrors.name" label='שם מלא' v-model="form.name"></smart-input>
		<smart-input required type="tel" :errors="inputErrors.tel" label='טלפון' v-model="form.tel"></smart-input>
		<smart-input required type="tel" :errors="inputErrors.id_number" label='תעודת זהות'
			v-model="form.id_number"></smart-input>
		<smart-input required type="email" :errors="inputErrors.email" label='דואר אלקטרוני'
			v-model="form.email"></smart-input>
		<div>
			<v-btn type="submit" class="mx-auto" :loading="inProgress" color="success" large block>הרשמה</v-btn>
		</div>
	</form>
</template>


<script>
	import ClientModule from "src/store/modules/Client.module";
	import FormView from "src/mixins/FormView";

	export default {
		props: {referrer: String},
		mixins: [new FormView(ClientModule, "client")],
		name: "register-client-form",
		data() {
			return {
				form: {},
				amount: 1
			};
		},
		methods: {
			onSuccess() {
				this.$emit("register", {client: this.form, amount: this.amount});
			},
		},
		mounted() {

			let queryString = this.referrer.split("?");
			if (queryString.length>1){
				let splitted = queryString[1].split("&");
				splitted.forEach((key) => {
					let finalSplit = key.split("=");
					this.$set(this.form, finalSplit[0], finalSplit[1]);
				});
			}
			["utm_source", "utm_medium", "utm_content", "token"].forEach((key) => {
				if (this.$route.query[key]) {
					this.$set(this.form, key, this.$route.query[key]);
				}
			});
		}
	};
</script>
